// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/
// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.
// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx
import baseIcon from '@bubble-ui/temp-icon-base';
var ActionIconChevronBottomPath = 'M9.748,12.889 C9.531,12.889 9.314,12.819 9.133,12.678 L4,8.678 L5.23,7.1 L9.748,10.62 L14.259,7.101 L15.489,8.677 L10.363,12.677 C10.183,12.819 9.965,12.889 9.748,12.889';
var ActionIconChevronBottom = baseIcon('ActionIconChevronBottom', {
  getPath: function getPath() {
    return ActionIconChevronBottomPath;
  }
});
export default ActionIconChevronBottom;
//# sourceMappingURL=index.js.map